import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, PrinterIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, PRICE, PRICE_FULL, Section } from './Shared';
import { KanjiBackdrop, Seal } from './Ornaments';
const benefits = [{
  icon: PrinterIcon,
  label: 'Listo para imprimir o usar en tablet durante la sesión'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro con tarjeta o Mercado Pago'
}, {
  icon: DownloadIcon,
  label: '100% PDF · Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días sin preguntas'
}];
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="paper-card my-12 rounded-sm border border-brand-gold/50 shadow-[0_20px_55px_rgba(44,38,32,0.11)]" data-id="element-236" data-mp="20vhfslqsq2g1">
      <KanjiBackdrop glyphs={['價', '值', '術', '道', '傳']} data-id="element-237" data-mp="3c7rzm2nkao8c" />
      <div className="mx-auto max-w-2xl text-center" data-id="element-238" data-mp="3vzym6f0q9521">
        <span className="inline-flex items-center gap-2 rounded-sm bg-brand-cinnabar px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-brand-paper" data-id="element-239" data-mp="3vz73g4s8b1t6">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-240" data-mp="9ta6jflp8qul" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-241" data-mp="eq0lu0pojiey">
          TU <span className="text-brand-cinnabar" data-id="element-242" data-mp="3daa6ft5g5v79">ATLAS ANCESTRAL</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-243" data-mp="3i7906al7804x">
          El precio de lanzamiento cierra pronto. Después sube a USD 29.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-244" data-mp="3n5akeyud25hz">
        <div className="rounded-sm border-2 border-brand-gold/60 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(124,95,42,0.14)] md:p-7" data-id="element-245" data-mp="3rywtyi589t9k">
          <div className="flex items-start gap-3" data-id="element-246" data-mp="2ugd9xhwe5czs">
            <Seal characters="第一" className="h-10 w-10 text-[11px]" data-id="element-247" data-mp="2zgr8m9c3ral5" />
            <span className="pt-1 font-serif text-[11px] font-bold uppercase tracking-[0.14em] text-brand-goldDark md:text-xs" data-id="element-248" data-mp="2rguxx8i4nmb3">
              El sistema visual más completo de acupuntura clínica en español
            </span>
          </div>
          <div className="mt-5 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-249" data-mp="315mqniv0ian2">
            <div data-id="element-250" data-mp="2w8mjf4mff1ud">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-251" data-mp="2w839ob6xjjrf">
                ATLAS ANCESTRAL DE ACUPUNTURA™
              </h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-252" data-mp="23ixhmp1w6xrp">
                3 Tomos + 6 Bonos · 118 páginas + material completo
              </p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-253" data-mp="2igy4yuopg1a8">
                El pack visual más completo de acupuntura y digitopuntura
                clínica para terapeutas formados que quieren perfeccionar su
                práctica, reducir la improvisación y aplicar con la precisión y
                autoridad que sus pacientes merecen.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-254" data-mp="92g0n9zafqb">
              <p className="text-sm text-brand-muted line-through" data-id="element-255" data-mp="59qgdzk3k8x7">
                {PRICE_FULL}
              </p>
              <p className="font-serif text-3xl font-bold text-brand-cinnabar" data-id="element-256" data-mp="3ngel3ob8iu2c">
                {PRICE}
              </p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-257" data-mp="j0d5d0022kg3">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-258" data-mp="e8u095r38scr">
            → QUIERO MI ATLAS ANCESTRAL {PRICE}
          </CTAButton>
        </motion.div>
        <ul className="mt-5 grid gap-2 sm:grid-cols-2" aria-label="Beneficios de compra" data-id="element-259" data-mp="16qfxfg3yzqep">
          {benefits.map(benefit => <li key={benefit.label} className="flex items-center gap-2 rounded-sm border border-brand-gold/35 bg-brand-paper px-3 py-3 text-[11px] font-semibold leading-tight text-brand-text md:text-xs" data-id="element-260" data-mp="3f8tny6iy92em">
              <CheckIcon className="h-4 w-4 shrink-0 text-brand-forest" aria-hidden="true" data-id="element-261" data-mp="3180r3f56dv8c" />
              <benefit.icon className="h-4 w-4 shrink-0 text-brand-goldDark" aria-hidden="true" data-id="element-262" data-mp="1rawec1ebd9h" />
              {benefit.label}
            </li>)}
        </ul>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-263" data-mp="3o6drjm4abase">
          <CreditCardIcon className="mr-1 inline h-3.5 w-3.5 text-brand-forest" data-id="element-264" data-mp="3k5k2uqj0pryg" />
          Tarjeta · Mercado Pago · Garantía de 7 días
        </p>
      </div>
    </Section>;
}